import * as React from 'react';
export const IcAnimation = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.53 4.47a4.51 4.51 0 00-6.36-.3A4 4 0 0013 7.08a6.54 6.54 0 00-2 0 4 4 0 00-1.17-2.91 4.51 4.51 0 00-6.36.3 4.51 4.51 0 00-.3 6.36 4 4 0 002.14 1.09A7.17 7.17 0 005 14a7 7 0 1014 0c0-.705-.105-1.406-.31-2.08a4.001 4.001 0 002.14-1.09 4.51 4.51 0 00-.3-6.36z'
      fill='currentColor'
    />
  </svg>
);
